import { useState, useEffect, useRef, useMemo, useCallback } from 'react'

import { createEditor, BaseEditor, Descendant, Editor, Transforms } from 'slate'
// Import the Slate components and React plugin.
import { Slate, Editable, withReact, ReactEditor } from 'slate-react'

type CustomElement = { type: 'paragraph' | 'code'; children: CustomText[] }
type CustomText = { text: string }

// If you are using TypeScript, you will also need to extend the Editor with ReactEditor
// and add annotations as per the documentation on TypeScript.
declare module 'slate' {
  interface CustomTypes {
    Editor: BaseEditor & ReactEditor
    Element: CustomElement
    Text: CustomText
  }
}

const CodeElement = (props) => {
  return (
    <pre {...props.attributes}>
      <span>Hehe</span>
      <code>{props.children}</code>
    </pre>
  )
}

const DefaultElement = (props) => {
  return <p {...props.attributes}>{props.children}</p>
}

const RadarEditor = ({ name, value: initValue, onChange }) => {
  const handleChange = (e) => {
    const _value = e.target.value
    onChange(_value, name)
  }

  return (
    <>
      <div>
        <textarea
          className="block p-2.5 h-40 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          onChange={handleChange}
        >
          {initValue}
        </textarea>
      </div>
    </>
  )
}

export default RadarEditor
